import { MIN_PASSWORD_LENGTH } from './const/passwords.mjs';

/**
 * Check if the password has at least the minimum number of characters.
 * @param {String} value The password
 * @returns {Boolean}
 */
export function hasMinCharacters(value) {
  return value.length >= MIN_PASSWORD_LENGTH;
}

/**
 * Check if the password has at least one uppercase character.
 * @param {String} value The password
 * @returns {Boolean}
 */
export function hasUppercase(value) {
  return /[A-Z\p{Uppercase}]/gu.test(value);
}

/**
 * Check if the password has at least one lowercase character.
 * @param {String} value The password
 * @returns {Boolean}
 */
export function hasLowercase(value) {
  return /[a-z\p{Lowercase}]/gu.test(value);
}

/**
 * Check if the password has at least one number.
 * @param {String} value The password
 * @returns {Boolean}
 */
export function hasNumber(value) {
  return /[\d]/gu.test(value);
}

/**
 * Check if the password has at least one symbol.
 * @param {String} value The password
 * @returns {Boolean}
 */
export function hasSymbol(value) {
  return /[^a-zA-Z0-9\p{Letter}]/gu.test(value);
}
